<template>
  <div class="danger-600">new</div>
</template>

<script>
  export default {
    name: 'NewAlert',
  };
</script>
